// @flow
import * as React from 'react';
import { Text } from 'grommet';


type Props = {

};

const LabelText = (props: Props) => (
    <Text {...props} size="12px" />
);

export default LabelText;
